import React from 'react'

const Tables = () => {
  return (
    <div>Tables</div>
  )
}

export default Tables